module.exports = __webpack_public_path__ + "static/media/icon_close.2e7dfff4.svg";